import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { cases } from '../data/mock';
import { useLang } from '../context/LanguageContext';

export default function CaseStudiesSection({ limit = 3 }) {
  const { t } = useLang();
  const list = cases.slice(0, limit);
  return (
    <section className="py-24 bg-[#faf6ec]">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="section-eyebrow mb-4">{t('cases.eyebrow')}</p>
          <h2 className="text-[36px] md:text-[44px] leading-[1.1] font-extrabold text-[#14110f]">
            {t('cases.titlePre')} <span className="text-[#f5b300]">{t('cases.titleAccent')}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {list.map((c) => {
            const catKey = `case.cat.${c.category.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;
            return (
            <Link
              key={c.id}
              to="/cases"
              className="group block rounded-xl overflow-hidden bg-white shadow-[0_18px_50px_-25px_rgba(20,17,15,0.2)] hover:shadow-[0_25px_60px_-25px_rgba(20,17,15,0.35)] hover:-translate-y-1.5 transition-all"
            >
              <div className="relative h-60 overflow-hidden">
                <img src={c.image} alt={t(`case.${c.slug}.title`)} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-4 left-4 bg-[#f5b300] text-[#14110f] text-[11px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-full">
                  {t(catKey)}
                </span>
                <div className="absolute inset-0 bg-gradient-to-t from-[#14110f]/55 via-transparent to-transparent" />
              </div>
              <div className="p-7">
                <h3 className="text-[20px] font-bold text-[#14110f] group-hover:text-[#c89200] transition-colors">{t(`case.${c.slug}.title`)}</h3>
                <p className="mt-3 text-[14px] text-neutral-500 leading-relaxed">{t(`case.${c.slug}.summary`)}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-[13.5px] font-semibold uppercase tracking-wide text-[#c89200]">
                  {t('cta.learnMore')} <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-0.5 transition-transform" />
                </span>
              </div>
            </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
